import { render } from "./InserimentoMassivoGas.vue?vue&type=template&id=086557aa&scoped=true"
import script from "./InserimentoMassivoGas.vue?vue&type=script&lang=js"
export * from "./InserimentoMassivoGas.vue?vue&type=script&lang=js"

import "./InserimentoMassivoGas.vue?vue&type=style&index=0&id=086557aa&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086557aa"]])

export default __exports__